import {createSlice} from '@reduxjs/toolkit';
import API from '../../common/api';
import {setError} from '../error/errorSlice';
import {resetAuth} from '../auth/authSlice';
import {clearUsers, createUsers, updateDevices} from '../../app/models/UsersModel';
import {clearLocations, createLocations} from '../../app/models/LocationsModel';
import {clearCircles, createCircles} from '../../app/models/CirclesModel';
import {clearDashboardData} from '../dashboard/dashboardSlice';
import {setAnalyticsUserId} from '../../analytics/common';
import {clearOnboardingData} from '../onboarding/onboardingSlice';
import {clearPaywallData} from '../paywall/paywallSlice';
import {createPendingUser} from '../../app/models/PendingUsersModel';

export const loginSlice = createSlice({
    name: 'login',
    initialState: {
        userInfo: {},
        status: null,
        isLogout: null,
    },
    reducers: {
        setUserInfo: (state, action) => {
            state.userInfo = action.payload;
        },
        setStatus: (state, action) => {
            state.status = action.payload;
        },
        setLogout: (state, action) => {
            state.isLogout = action.payload;
            state.userInfo = {};
            state.status = null;
        },
    },
});

export const {setUserInfo, setStatus, setLogout} = loginSlice.actions;

export const fetchData = token => async dispatch => {
    try {
        const userData = await API.getUserInfo(token);
        const userGeoInfo = await API.setAllUsersGeoInfo(token);
        const circlesInfo = await API.getCirclesInfo(token);
        const devicesInfo = await API.getDevicesInfo(token);
        const invitesInfo = await API.getAllInvites(token);
        dispatch(setUserInfo(userData));
        setAnalyticsUserId(userData.id);

        dispatch(createUsers({userData: circlesInfo, devicesData: devicesInfo}));
        dispatch(updateDevices(devicesInfo));
        dispatch(createLocations(userGeoInfo));
        dispatch(createCircles(circlesInfo));
        dispatch(createPendingUser(invitesInfo));

        dispatch(setStatus(true));

    } catch (e) {
        dispatch(setError({show: true, type: 'fetching user info', text: e.message}));
    }
};

export const sendLogoutRequest = (token) => async dispatch => {
    try {
        await API.logoutUser(token);

    } catch (e) {
        dispatch(setError({show: true, type: 'user logout', text: e.message}));
    }

    finally {
        dispatch(setLogout(true));
        dispatch(resetAuth());
        dispatch(clearCircles());
        dispatch(clearUsers());
        dispatch(clearLocations());
        dispatch(clearDashboardData());
        dispatch(clearOnboardingData());
        dispatch(clearPaywallData());
        sessionStorage.clear();
    }
};


export const selectUserInfo = state => state.login.userInfo;
export const selectStatus = state => state.login.status;
export const selectIsLogout = state => state.login.isLogout;


export default loginSlice.reducer;
